import React, { useCallback } from 'react';
import YesNoModal from '../../components/YesNoModal';
import { useMutation, gql } from '@apollo/client';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { notification } from 'antd';
import { deleteLoanAgreementAction } from '../../redux-store/loan-agreements-store';
import { deleteLoanAgreementMutation } from './constants';

function DeleteLoanAgreementTemplateModal({
  loanAgreementTemplate,
  onFinish,
  onCancel,
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deleteLoanAgreement] = useMutation(deleteLoanAgreementMutation);
  const dispatch = useDispatch();

  const onYes = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      await deleteLoanAgreement({
        variables: {
          _id: loanAgreementTemplate._id,
        },
      });
      dispatch(deleteLoanAgreementAction(loanAgreementTemplate._id));
      notification.success({
        message: 'Deleted',
        description: 'Loan Agreement Template deleted successfully',
      });
      setTimeout(() => {
        onFinish();
      }, 1000);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  }, [loanAgreementTemplate, deleteLoanAgreement, dispatch, onFinish]);

  const onNo = useCallback(() => {
    if (!loading) {
      onCancel();
    }
  }, [onCancel, loading]);

  return (
    <YesNoModal
      title="Delete Loan Template Agreement"
      question={`Are you sure you want to delete this loan agreement template (${
        loanAgreementTemplate && loanAgreementTemplate.name
      })?`}
      yesText="Delete"
      noText="Cancel"
      onYes={onYes}
      onNo={onNo}
      visible={!!loanAgreementTemplate}
      loading={loading}
      error={error}
    />
  );
}

export default DeleteLoanAgreementTemplateModal;
